import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const RestaurantAddBranchManage = ({ menuOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const type = location?.state?.type;

  return (
    <div
      className={menuOpen ? "side-content2" : "side-content"}
      style={{ transition: "0.5s" }}
    >
      <div className="menu-list">
        <h1>{type === "edit" ? "Edit User" : "Add User"}</h1>
      </div>
      <div className="side_pad">
        <div className="add-food-section">
          <div action="">
            <div className="d-flex flex-wrap">
              <div className="col-md-6 col-12 px-md-3 px-0 position-relative mb-3">
                <label className="mb-2" htmlFor="">
                  Branch Name
                </label>
                <input
                  name="name"
                  type="text"
                  className="form-control"
                  placeholder="Enter Company name"
                />
              </div>
              <div className="col-md-6 col-12 px-md-3 px-0 position-relative mb-3">
                <label className="mb-2" htmlFor="">
                  Location
                </label>
                <input
                  name="name"
                  type="text"
                  className="form-control"
                  placeholder="Enter Your name"
                />
              </div>

              <div className="col-md-6 col-12 px-md-3 px-0 position-relative mb-3">
                <label className="mb-2" htmlFor="">
                  Contact Number
                </label>
                <input
                  name="name"
                  type="text"
                  className="form-control"
                  placeholder="Enter Contact Number"
                />
              </div>
              <div className="col-md-6 col-12 px-md-3 px-0 position-relative mb-3">
                <label className="mb-2" htmlFor="">
                  Email Id
                </label>
                <input
                  name="name"
                  type="text"
                  className="form-control"
                  placeholder="Enter Email Id"
                />
              </div>
              <div className="col-md-6 col-12 px-md-3 px-0 position-relative mb-3">
                <label className="mb-2" htmlFor="">
                  Branch Password
                </label>
                <input
                  name="name"
                  type="text"
                  className="form-control"
                  placeholder="Enter Company Password"
                />
              </div>
              <div className="col-md-6 col-12 px-md-3 px-0 position-relative mb-3">
                <label className="mb-2" htmlFor="">
                  File Upload
                </label>
                <input name="name" type="file" className="form-control" />
              </div>

              <div className="col-md-12 col-12 px-md-3 px-0 position-relative mb-3">
                <label className="mb-2" htmlFor="">
                  Description
                </label>
                <textarea
                  name="name"
                  type="text"
                  className="form-control"
                  placeholder="Enter Description"
                  cols="30"
                  rows="4"
                ></textarea>
              </div>

              <div onClick={() => navigate(-1)} className="px-md-3 pe-3">
                <input className="btn-submit" type="submit" />
              </div>
              <div onClick={() => navigate(-1)} class="btn-outline">
                <p style={{ margin: 0 }}>Back</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestaurantAddBranchManage;
